import React, { useState } from "react";
import { ErrorMessage, Field } from "formik";
import axios from "axios";

interface NewTextAreaProps {
    label?: string;
    required?: boolean;
    backgroundColor?: string;
    name: string;
    placeHolder?: string;
    rows?: number;
    cols?: number;
    customHeight?: string;
    labelClassNames?: string;
    labelStyle?: React.CSSProperties;
    disabled?: boolean;
    autoGenerate?: boolean;
    generate?: object;
}

const NewTextArea: React.FC<NewTextAreaProps> = ({
    label,
    required,
    backgroundColor,
    name,
    placeHolder = " ",
    rows = 4,
    cols = 50,
    customHeight,
    labelClassNames,
    labelStyle,
    disabled,
    autoGenerate = false,
    generate = {},
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [generated, setGenerated] = useState(false);

    const handleGenerateText = async (form: any) => {
        try {
            setIsLoading(true);
            const response = await axios.post(
                `https://dev.soomuch.ai/api/v1/master/textGenerate`,
                generate
            );
            form.setFieldValue(name, response?.data?.data?.text);
            setGenerated(true);
        } catch (err) {
            console.error("Error generating text:", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="mb-6 relative w-full">
            {label && (
                <label
                    htmlFor={name}
                    style={labelStyle}
                    className={`block mb-2 font-medium ${labelClassNames || ""}`}
                >
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <Field name={name}>
                {({ field, form }: { field: any; form: any }) => (
                    <div className="relative">
                        <textarea
                            disabled={disabled}
                            id={name}
                            className="w-full p-4 border rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700 leading-5 transition-colors duration-200 ease-in-out outline-none border-gray-300"
                            placeholder={placeHolder}
                            rows={rows}
                            required={required}
                            value={field.value}
                            style={{
                                resize: "none",
                                overflow: "hidden",
                                height: "auto", // Ensures the height doesn't expand unexpectedly
                                minHeight: "100px", // Adjust as needed
                            }}
                            onChange={(event) => form.setFieldValue(name, event.target.value)}
                        />



                        {/* Overlay for auto-generated text */}
                        {!disabled && autoGenerate && !generated && (
                            <div
                                className="absolute inset-0 flex flex-col items-center justify-center border rounded-xl cursor-pointer"
                                onClick={() => {
                                    if (!isLoading) handleGenerateText(form);
                                }}
                            >
                                <div className="w-13 h-13 -full flex items-center justify-center mb-1">
                                    <img
                                        src="/images/magicbrush.svg"
                                        className="w-8 h-8"
                                        alt="Magic Brush Icon"
                                    />
                                </div>
                                <p className="text-center text-black text-sm">
                                    {isLoading
                                        ? "Generating text..."
                                        : "Fill above details our AI will generate content for u."}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </Field>
            <ErrorMessage
                name={name}
                component="div"
                className="text-red-500 mt-1 text-sm"
            />
        </div>
    );
};

export default NewTextArea;